import { render, staticRenderFns } from "./DocumentsForm.vue?vue&type=template&id=0f431da6&scoped=true&"
import script from "./DocumentsForm.vue?vue&type=script&lang=js&"
export * from "./DocumentsForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsForm.vue?vue&type=style&index=0&id=0f431da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f431da6",
  null
  
)

export default component.exports